var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "mr-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.onBack()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "chevron-left" }
                  }),
                  _vm._v("\n        Назад\n      ")
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "mx-2 mt-1" },
            [
              _vm.isBusy
                ? [
                    _c("h4", { attrs: { id: "invoice-ellipsis-loading" } }, [
                      _vm._v("Загрузка счёта")
                    ])
                  ]
                : [_c("h4", [_vm._v(_vm._s(_vm.title))])]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-2" },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    [
                      _c("span", { staticClass: "text-small" }, [
                        _vm._v("Статус")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-badge",
                        {
                          attrs: {
                            pill: "",
                            variant: _vm.getStatusStyle(_vm.newItem.paid_type)
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getStatusName(_vm.newItem.paid_type)) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto mr-3" },
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.loading,
                            rounded: "",
                            opacity: "0.6",
                            "spinner-small": "",
                            "spinner-variant": "success"
                          },
                          on: { hidden: _vm.onHiddenExportButtonOverlay }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              ref: "exportFileButton",
                              attrs: { size: "sm", variant: "info" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.exportFileGate("docx")
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "file" }
                              }),
                              _vm._v(
                                "\n              Счёт в Docx\n            "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.loading,
                            rounded: "",
                            opacity: "0.6",
                            "spinner-small": "",
                            "spinner-variant": "success"
                          },
                          on: { hidden: _vm.onHiddenExportPdfButtonOverlay }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              ref: "exportPdfFileButton",
                              attrs: { size: "sm", variant: "info" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.exportFileGate("pdf")
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "file-pdf" }
                              }),
                              _vm._v("\n              Счёт в PDF\n            ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "success",
                            disabled: _vm.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSubmit()
                            }
                          }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "save" }
                          }),
                          _vm._v("\n            Сохранить\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-skeleton-wrapper", {
        attrs: { loading: _vm.isBusy },
        scopedSlots: _vm._u([
          {
            key: "loading",
            fn: function() {
              return [
                _c(
                  "b-card",
                  { staticClass: "mb-2", attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-card-body",
                      { staticClass: "p-3" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "7" } },
                              [
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      "no-body": "",
                                      "bg-variant": "light"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card-body",
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "mt-2 mb-3" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    width: "36%",
                                                    height: "16%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    type: "input",
                                                    width: "100%",
                                                    height: "28%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  attrs: {
                                                    width: "80%",
                                                    height: "35%"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    width: "22%",
                                                    height: "16%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  attrs: {
                                                    type: "input",
                                                    width: "100%",
                                                    height: "28%"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "4" } },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    width: "38%",
                                                    height: "16%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  attrs: {
                                                    type: "input",
                                                    width: "100%",
                                                    height: "28%"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-row",
                                          { staticClass: "pb-3" },
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "6" } },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    width: "46%",
                                                    height: "24%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  attrs: {
                                                    type: "input",
                                                    width: "100%",
                                                    height: "43%"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { lg: "6" } },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-2",
                                                  attrs: {
                                                    width: "35%",
                                                    height: "24%"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("b-skeleton", {
                                                  attrs: {
                                                    type: "input",
                                                    width: "100%",
                                                    height: "70%"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  { staticClass: "mt-2" },
                                  [
                                    _c(
                                      "b-col",
                                      [
                                        _c("b-skeleton", {
                                          attrs: {
                                            type: "input",
                                            width: "100%",
                                            height: "130%"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { lg: "5" } },
                              [
                                _c(
                                  "b-card",
                                  {
                                    attrs: {
                                      "no-body": "",
                                      "bg-variant": "light"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-card-header",
                                      [
                                        _c("b-skeleton", {
                                          attrs: { width: "13%", height: "50%" }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-list-group",
                                      {
                                        attrs: {
                                          flush: "",
                                          "bg-variant": "light"
                                        }
                                      },
                                      _vm._l(8, function(i) {
                                        return _c(
                                          "b-list-group-item",
                                          {
                                            key: "skeleton-item-" + i,
                                            staticClass:
                                              "d-flex justify-content-between align-items-center",
                                            class: {
                                              "mb-2":
                                                i === 2 || i === 5 || i === 6,
                                              "border-top":
                                                i === 3 || i === 6 || i === 7
                                            },
                                            attrs: { "bg-variant": "light" }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-grow-1" },
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mb-0",
                                                  attrs: {
                                                    width: _vm.getLeftSkeletonWidth(
                                                      i
                                                    ),
                                                    height: "20%"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("b-skeleton", {
                                                  staticClass: "mr-5",
                                                  attrs: {
                                                    width: _vm.getRightSkeletonWidth(
                                                      i
                                                    )
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-tabs",
                  { attrs: { card: "" } },
                  [
                    _c("b-tab", { attrs: { title: "Заявки", disabled: "" } }),
                    _vm._v(" "),
                    _c("b-tab", { attrs: { title: "Работы", disabled: "" } }),
                    _vm._v(" "),
                    _c("b-tab", { attrs: { title: "Акты", disabled: "" } }),
                    _vm._v(" "),
                    _c("b-tab", { attrs: { title: "Оплаты", disabled: "" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-card",
                  { attrs: { "border-variant": "white" } },
                  [
                    _c(
                      "b-card",
                      { attrs: { "no-body": "" } },
                      [
                        _c(
                          "b-card-header",
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mr-auto",
                                    attrs: { cols: "auto", "align-v": "center" }
                                  },
                                  [
                                    _c("h5", { staticClass: "text-muted" }, [
                                      _vm._v("Заявки")
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mr-5",
                                    attrs: { cols: "auto" }
                                  },
                                  [
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "260%",
                                        height: "80%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-card",
                          { attrs: { "no-body": "", "bg-variant": "light" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-center text-muted d-flex align-items-center justify-content-center"
                              },
                              [
                                _c("div", { staticClass: "spinner" }, [
                                  _c("div", { staticClass: "rect1" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "rect2" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "rect3" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "rect4" }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "rect5" })
                                ]),
                                _vm._v(" "),
                                _c("h5", [_vm._v("Загрузка заявок")])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isBusy,
              expression: "!isBusy"
            }
          ]
        },
        [
          _c(
            "b-card",
            { staticClass: "mb-2", attrs: { "no-body": "" } },
            [
              _c(
                "b-card-body",
                { staticClass: "p-3" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { lg: "7" } },
                        [
                          _c(
                            "b-card",
                            { attrs: { "no-body": "", "bg-variant": "light" } },
                            [
                              _c(
                                "b-card-body",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-numb",
                                                label: "Счет №",
                                                "label-for": "input-numb",
                                                description:
                                                  "Для автоподстановки номера оставьте поле пустым или 0"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input_numb",
                                                  size: "sm",
                                                  autocomplete: "off"
                                                },
                                                model: {
                                                  value: _vm.newItem.numb,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "numb",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression: "newItem.numb"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-date",
                                                label: "Дата",
                                                "label-for": "input-date"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input-date",
                                                  size: "sm",
                                                  type: "date"
                                                },
                                                model: {
                                                  value: _vm.newItem.date,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "date",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.date"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "4" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group-contract",
                                                label: "Договор",
                                                "label-for": "input-contract"
                                              }
                                            },
                                            [
                                              _c("b-form-input", {
                                                attrs: {
                                                  id: "input_contract",
                                                  size: "sm",
                                                  autocomplete: "off"
                                                },
                                                model: {
                                                  value: _vm.newItem.contract,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.newItem,
                                                      "contract",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "newItem.contract"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group_organization",
                                                label: "Организация продавец",
                                                "label-for":
                                                  "input_organization"
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function() {
                                                    return [
                                                      _vm._v(
                                                        "\n                        Организация\n                        "
                                                      ),
                                                      _c(
                                                        "b-link",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "b-modal",
                                                              rawName:
                                                                "v-b-modal.modal-organization",
                                                              modifiers: {
                                                                "modal-organization": true
                                                              }
                                                            },
                                                            {
                                                              name: "b-tooltip",
                                                              rawName:
                                                                "v-b-tooltip.hover",
                                                              modifiers: {
                                                                hover: true
                                                              }
                                                            }
                                                          ],
                                                          staticClass:
                                                            "text-decoration-none text-small text-body",
                                                          attrs: {
                                                            title: "Реквизиты"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "id-card"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-modal",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "modal-organization",
                                                            title: "Реквизиты",
                                                            "ok-only": "",
                                                            size: "lg"
                                                          }
                                                        },
                                                        [
                                                          _c("p", [
                                                            _vm._v(
                                                              "\n                            " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .full_name
                                                                ) +
                                                                " "
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            ИНН/КПП " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .inn
                                                                ) +
                                                                " / " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .kpp
                                                                )
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            ОГРН " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .ogrn
                                                                )
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            Адрес " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .address
                                                                )
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            Расчетный счет " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .checking_account
                                                                )
                                                            ),
                                                            _c("br"),
                                                            _vm._v(
                                                              "\n                            БИК " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .bik
                                                                ) +
                                                                " , " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .bank
                                                                ) +
                                                                " , Кор. счет " +
                                                                _vm._s(
                                                                  _vm
                                                                    .selectedOrganization
                                                                    .cor_account
                                                                ) +
                                                                "\n                          "
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ])
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "b-form-select",
                                                {
                                                  attrs: {
                                                    size: "sm",
                                                    id: "input_organization"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedOrganization,
                                                    callback: function($$v) {
                                                      _vm.selectedOrganization = $$v
                                                    },
                                                    expression:
                                                      "selectedOrganization"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.organizations,
                                                  function(option) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        domProps: {
                                                          value: option
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                          " +
                                                            _vm._s(
                                                              option.name
                                                            ) +
                                                            " (ИНН " +
                                                            _vm._s(option.inn) +
                                                            " / КПП " +
                                                            _vm._s(option.kpp) +
                                                            ")\n                        "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "6" } },
                                        [
                                          _c(
                                            "b-form-group",
                                            {
                                              attrs: {
                                                id: "group_customer",
                                                label: "Организация покупатель",
                                                "label-for": "input_customer"
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "label",
                                                  fn: function() {
                                                    return [
                                                      _vm._v(
                                                        "\n                        Заказчик\n                        "
                                                      ),
                                                      _vm.customer.name
                                                        ? _c(
                                                            "b-link",
                                                            {
                                                              directives: [
                                                                {
                                                                  name:
                                                                    "b-modal",
                                                                  rawName:
                                                                    "v-b-modal.modal-customer",
                                                                  modifiers: {
                                                                    "modal-customer": true
                                                                  }
                                                                },
                                                                {
                                                                  name:
                                                                    "b-tooltip",
                                                                  rawName:
                                                                    "v-b-tooltip.hover",
                                                                  modifiers: {
                                                                    hover: true
                                                                  }
                                                                }
                                                              ],
                                                              staticClass:
                                                                "text-decoration-none text-small text-body",
                                                              attrs: {
                                                                title:
                                                                  "Реквизиты"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "font-awesome-icon",
                                                                {
                                                                  attrs: {
                                                                    icon:
                                                                      "id-card"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "b-modal",
                                                        {
                                                          attrs: {
                                                            id:
                                                              "modal-customer",
                                                            title: "Реквизиты",
                                                            "ok-only": "",
                                                            size: "lg"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-small"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .full_name
                                                                  ) +
                                                                  " "
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                            ИНН/КПП " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .inn
                                                                  ) +
                                                                  " / " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .kpp
                                                                  )
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                            ОГРН " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .ogrn
                                                                  )
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                            Адрес " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .address
                                                                  )
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                            Расчетный счет " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .checking_account
                                                                  )
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                "\n                            БИК " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .bik
                                                                  ) +
                                                                  " , " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .bank
                                                                  ) +
                                                                  " , Кор. счет " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .cor_account
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ])
                                            },
                                            [
                                              _vm._v(" "),
                                              _vm.customer.name
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-card",
                                                        {
                                                          attrs: {
                                                            "no-body": ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "my-1 mx-2 text-small"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.customer
                                                                      .name
                                                                      ? _vm
                                                                          .customer
                                                                          .name +
                                                                          " (ИНН " +
                                                                          _vm
                                                                            .customer
                                                                            .inn +
                                                                          " /  КПП " +
                                                                          _vm
                                                                            .customer
                                                                            .kpp +
                                                                          ")"
                                                                      : "-"
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v("Не определён")
                                                  ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-alert",
                            {
                              staticClass: "mt-2",
                              attrs: {
                                show: true,
                                variant:
                                  this.newItem.summa !== this.totalPriceTasks
                                    ? "danger"
                                    : "success"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    this.newItem.summa !== this.totalPriceTasks
                                      ? "Внимание! Сумма по счёту не совпадает с суммой по заявкам."
                                      : "Сумма по счёту совпадает с суммой по заявкам."
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { lg: "5" } },
                        [
                          _c(
                            "b-card",
                            { attrs: { "no-body": "", "bg-variant": "light" } },
                            [
                              _c("b-card-header", [
                                _c("h6", { attrs: { id: "invoice-header" } }, [
                                  _vm._v("Итого")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                { attrs: { flush: "", "bg-variant": "light" } },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Сумма по счёту\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(this.newItem.summa)
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Кол-во работ\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(this.newItem.works.length)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                {
                                  staticClass: "mt-2",
                                  attrs: { flush: "", "bg-variant": "light" }
                                },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Кол-во заявок\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(this.tasks.length))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Единиц(часов, шт.) по заявкам\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              this.totalHoursTasks
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Сумма по заявкам\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              this.totalPriceTasks
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                {
                                  staticClass: "mt-2",
                                  attrs: { flush: "", "bg-variant": "light" }
                                },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Кол-во актов\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(this.newItem.acts.length))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-list-group",
                                {
                                  staticClass: "mt-2",
                                  attrs: { flush: "", "bg-variant": "light" }
                                },
                                [
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Кол-во оплат\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(this.newItem.payments.length)
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-list-group-item",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between align-items-center",
                                      attrs: { "bg-variant": "light" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Сумма по оплатам\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.priceFormat(
                                              this.totalPaymentsSum
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tabs",
            { attrs: { card: "" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "Заявки", active: "" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        [
                          _c(
                            "b-row",
                            { attrs: { "align-v": "center" } },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("h5", { staticClass: "mb-0" }, [
                                    _vm._v("Заявки")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "success" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.onAddTask()
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: { icon: "plus" }
                                      }),
                                      _vm._v(
                                        "\n                  Добавить\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        ref: "invoice-tasks",
                        staticClass: "mb-0",
                        attrs: {
                          id: "invoice-tasks",
                          selectable: "",
                          "select-mode": "single",
                          selectedVariant: "success",
                          striped: "",
                          small: "",
                          "thead-class": "top-fixed-thead thead-light",
                          "table-class": "text-small",
                          responsive: "",
                          "show-empty": "",
                          "empty-text": _vm.$t("message.common.emptyTable"),
                          items: _vm.tasks,
                          fields: _vm.fields,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-success my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("Загрузка")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(start_address)",
                            fn: function(row) {
                              return [
                                row.item.start_address.length < 100
                                  ? _c("div", [
                                      _vm._v(_vm._s(row.item.start_address))
                                    ])
                                  : _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          row.item.start_address.substring(
                                            0,
                                            100
                                          ) + ".."
                                        )
                                      )
                                    ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "m-0 p-0 text-secondary text-small"
                                  },
                                  [_vm._v(_vm._s(row.item.customer_name))]
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(start_date)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatTableDateTime(
                                        row.item.start_date
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(total_price)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.priceFormat(row.item.total_price)
                                    ) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(paid)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.paid(row)) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(read_only)",
                            fn: function(row) {
                              return [
                                _c("font-awesome-icon", {
                                  style: _vm.readOnly(row).style,
                                  attrs: {
                                    icon: ["fas", _vm.readOnly(row).icon]
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: { size: "sm", variant: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onRemoveTask(row)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "trash" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "b-card-footer",
                        { attrs: { "footer-bg-variant": "light" } },
                        [
                          _c(
                            "b-row",
                            {
                              attrs: {
                                "align-h": "between",
                                "align-v": "center"
                              }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _vm._v("\n                Кол-во заявок: "),
                                  _c("b", [_vm._v(_vm._s(this.tasks.length))]),
                                  _vm._v(" |\n                "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.workTypeHours)
                                    }
                                  }),
                                  _vm._v(
                                    " |\n                Сумма по заявкам: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.totalPriceTasks)
                                      )
                                    )
                                  ]),
                                  _vm._v(" |\n                Всего работ: "),
                                  _c("b", [
                                    _vm._v(_vm._s(this.newItem.works.length))
                                  ]),
                                  _vm._v(
                                    " |\n                Сумма по счёту: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.newItem.summa)
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("b-pagination", {
                                    attrs: {
                                      id: "invoice-tasks-pagination",
                                      pills: "",
                                      "total-rows": this.tasks.length,
                                      "per-page": _vm.perPage
                                    },
                                    model: {
                                      value: _vm.currentPage,
                                      callback: function($$v) {
                                        _vm.currentPage = $$v
                                      },
                                      expression: "currentPage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Работы" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        [
                          _c(
                            "b-row",
                            { attrs: { "align-v": "center" } },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("h5", { staticClass: "mb-0" }, [
                                    _vm._v("Работы")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "success" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.onAddWork()
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: { icon: "plus" }
                                      }),
                                      _vm._v(
                                        "\n                  Добавить\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        ref: "invoice-works",
                        staticClass: "mb-0",
                        attrs: {
                          id: "invoice-works",
                          selectable: "",
                          "select-mode": "single",
                          selectedVariant: "success",
                          striped: "",
                          small: "",
                          "thead-class": "top-fixed-thead thead-light",
                          "table-class": "text-small",
                          responsive: "",
                          "show-empty": "",
                          "empty-text": _vm.$t("message.common.emptyTable"),
                          items: _vm.newItem.works,
                          fields: _vm.worksFields,
                          "per-page": _vm.worksPerPage,
                          "current-page": _vm.worksCurrentPage,
                          "sort-by": _vm.worksSortBy,
                          "sort-desc": _vm.worksSortDesc,
                          "sort-compare": _vm.sortCompare,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.worksSortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.worksSortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.worksSortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.worksSortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-success my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("Загрузка")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(index)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.index + 1) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(work_type_id)",
                            fn: function(row) {
                              return [
                                _c("b-form-select", {
                                  attrs: {
                                    id: "input_work_type",
                                    size: "sm",
                                    options: _vm.work_type_catalogs
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.updateName(row.item)
                                    }
                                  },
                                  model: {
                                    value: row.item.work_type_id,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "work_type_id", $$v)
                                    },
                                    expression: "row.item.work_type_id"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(name)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_name",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.name,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "name", $$v)
                                    },
                                    expression: "row.item.name"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(price)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  staticClass: "widthPrice",
                                  attrs: {
                                    id: "input_price",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.price,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "price", _vm._n($$v))
                                    },
                                    expression: "row.item.price"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(count)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  staticClass: "widthPrice",
                                  attrs: {
                                    id: "input_count",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.count,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "count", _vm._n($$v))
                                    },
                                    expression: "row.item.count"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(nds)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.item.nds) +
                                    "%\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(unit)",
                            fn: function(row) {
                              return [
                                _c("unit-select", {
                                  ref: "unit_select",
                                  attrs: {
                                    id: "input_unit",
                                    "initial-unit": row.item.unit_code,
                                    "is-short": ""
                                  },
                                  on: {
                                    selectUnit: function($event) {
                                      return _vm.updateUnit($event, row)
                                    }
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(summa)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.priceFormat(row.item.summa)) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { size: "sm", variant: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onRemoveWork(row)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "trash" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "b-card-footer",
                        { attrs: { "footer-bg-variant": "light" } },
                        [
                          _c(
                            "b-row",
                            {
                              attrs: {
                                "align-h": "between",
                                "align-v": "center"
                              }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _vm._v("\n                Кол-во заявок: "),
                                  _c("b", [_vm._v(_vm._s(this.tasks.length))]),
                                  _vm._v(
                                    " |\n                Часов по заявкам: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.totalHoursTasks)
                                      )
                                    )
                                  ]),
                                  _vm._v(
                                    " |\n                Сумма по заявкам: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.totalPriceTasks)
                                      )
                                    )
                                  ]),
                                  _vm._v(" |\n                Всего работ: "),
                                  _c("b", [
                                    _vm._v(_vm._s(this.newItem.works.length))
                                  ]),
                                  _vm._v(
                                    " |\n                Сумма по счёту: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.newItem.summa)
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("b-pagination", {
                                    attrs: {
                                      id: "invoice-works-pagination",
                                      pills: "",
                                      "total-rows": this.newItem.works.length,
                                      "per-page": _vm.worksPerPage
                                    },
                                    model: {
                                      value: _vm.worksCurrentPage,
                                      callback: function($$v) {
                                        _vm.worksCurrentPage = $$v
                                      },
                                      expression: "worksCurrentPage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Акты" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        [
                          _c(
                            "b-row",
                            { attrs: { "align-v": "center" } },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("h5", { staticClass: "mb-0" }, [
                                    _vm._v("Акты")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "success" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.onAddAct()
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: { icon: "plus" }
                                      }),
                                      _vm._v(
                                        "\n                  Создать\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        ref: "invoice-acts",
                        staticClass: "mb-0",
                        attrs: {
                          id: "invoice-acts",
                          selectable: "",
                          "select-mode": "single",
                          selectedVariant: "success",
                          striped: "",
                          small: "",
                          "thead-class": "top-fixed-thead thead-light",
                          "table-class": "text-small",
                          responsive: "",
                          "show-empty": "",
                          "empty-text": _vm.$t("message.common.emptyTable"),
                          items: _vm.newItem.acts,
                          fields: _vm.actsFields,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-success my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("Загрузка")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(numb)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_number",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.numb,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "numb", _vm._n($$v))
                                    },
                                    expression: "row.item.numb"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(date)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_date",
                                    size: "sm",
                                    type: "date"
                                  },
                                  model: {
                                    value: row.item.date,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "date", $$v)
                                    },
                                    expression: "row.item.date"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(contract)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_contract",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.contract,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "contract", $$v)
                                    },
                                    expression: "row.item.contract"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(town)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_town",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.town,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "town", $$v)
                                    },
                                    expression: "row.item.town"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(document)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-overlay",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      show: _vm.loading,
                                      rounded: "",
                                      opacity: "0.6",
                                      "spinner-small": "",
                                      "spinner-variant": "success"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "info",
                                          disabled: row.item.id === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.exportActFileGate(
                                              row,
                                              "docx"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "file" }
                                        }),
                                        _vm._v(
                                          "\n                  Docx\n                "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-overlay",
                                  {
                                    staticClass: "d-inline-block",
                                    attrs: {
                                      show: _vm.loading,
                                      rounded: "",
                                      opacity: "0.6",
                                      "spinner-small": "",
                                      "spinner-variant": "success"
                                    }
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "info",
                                          disabled: row.item.id === 0
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.exportActFileGate(
                                              row,
                                              "pdf"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass: "mr-1",
                                          attrs: { icon: "file-pdf" }
                                        }),
                                        _vm._v(
                                          "\n                  PDF\n                "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { size: "sm", variant: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onEditAct(row.item)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "edit" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    attrs: { size: "sm", variant: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onRemoveAct(row)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "trash" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "b-card-footer",
                        { attrs: { "footer-bg-variant": "light" } },
                        [
                          _c(
                            "b-row",
                            {
                              attrs: {
                                "align-h": "between",
                                "align-v": "center"
                              }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _vm._v("\n                Всего актов: "),
                                  _c("b", [
                                    _vm._v(_vm._s(this.newItem.acts.length))
                                  ]),
                                  _vm._v(" |\n                Всего работ: "),
                                  _c("b", [
                                    _vm._v(_vm._s(this.newItem.works.length))
                                  ]),
                                  _vm._v(
                                    " |\n                Сумма по счёту: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.newItem.summa)
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("b-pagination", {
                                    attrs: {
                                      id: "invoice-acts-pagination",
                                      pills: "",
                                      "total-rows": this.newItem.acts.length,
                                      "per-page": _vm.actsPerPage
                                    },
                                    model: {
                                      value: _vm.actsCurrentPage,
                                      callback: function($$v) {
                                        _vm.actsCurrentPage = $$v
                                      },
                                      expression: "actsCurrentPage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Оплаты" } },
                [
                  _c(
                    "b-card",
                    { attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-card-header",
                        [
                          _c(
                            "b-row",
                            { attrs: { "align-v": "center" } },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _c("h5", { staticClass: "mb-0" }, [
                                    _vm._v("Оплаты")
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "success" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.onAddPayment()
                                        }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        attrs: { icon: "plus" }
                                      }),
                                      _vm._v(
                                        "\n                  Добавить\n                "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        ref: "invoice-payments",
                        staticClass: "mb-0",
                        attrs: {
                          id: "invoice-payments",
                          selectable: "",
                          "select-mode": "single",
                          selectedVariant: "success",
                          striped: "",
                          small: "",
                          "thead-class": "top-fixed-thead thead-light",
                          "table-class": "text-small",
                          responsive: "",
                          "show-empty": "",
                          "empty-text": _vm.$t("message.common.emptyTable"),
                          items: _vm.newItem.payments,
                          fields: _vm.paymentsFields,
                          "per-page": _vm.paymentsPerPage,
                          "current-page": _vm.paymentsCurrentPage,
                          "sort-by": _vm.paymentsSortBy,
                          "sort-desc": _vm.paymentsSortDesc,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.paymentsSortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.paymentsSortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.paymentsSortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.paymentsSortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-center text-success my-2"
                                  },
                                  [
                                    _c("b-spinner", {
                                      staticClass: "align-middle"
                                    }),
                                    _vm._v(" "),
                                    _c("strong", [_vm._v("Загрузка")])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(numb)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_number",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.numb,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "numb", _vm._n($$v))
                                    },
                                    expression: "row.item.numb"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(date)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_date",
                                    size: "sm",
                                    type: "date"
                                  },
                                  model: {
                                    value: row.item.date,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "date", $$v)
                                    },
                                    expression: "row.item.date"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(sum)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  staticClass: "widthPrice",
                                  attrs: {
                                    id: "input_contract",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.sum,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "sum", _vm._n($$v))
                                    },
                                    expression: "row.item.sum"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(comment)",
                            fn: function(row) {
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "input_town",
                                    size: "sm",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: row.item.comment,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "comment", $$v)
                                    },
                                    expression: "row.item.comment"
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { size: "sm", variant: "danger" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onRemovePayment(row)
                                      }
                                    }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "trash" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "b-card-footer",
                        { attrs: { "footer-bg-variant": "light" } },
                        [
                          _c(
                            "b-row",
                            {
                              attrs: {
                                "align-h": "between",
                                "align-v": "center"
                              }
                            },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mr-auto",
                                  attrs: { cols: "auto" }
                                },
                                [
                                  _vm._v("\n                Всего оплат: "),
                                  _c("b", [
                                    _vm._v(_vm._s(this.newItem.payments.length))
                                  ]),
                                  _vm._v(
                                    " |\n                Сумма по оплатам: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.totalPaymentsSum)
                                      )
                                    )
                                  ]),
                                  _vm._v(" |\n                Всего работ: "),
                                  _c("b", [
                                    _vm._v(_vm._s(this.newItem.works.length))
                                  ]),
                                  _vm._v(
                                    " |\n                Сумма по счёту: "
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.priceFormat(this.newItem.summa)
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c("b-pagination", {
                                    attrs: {
                                      id: "invoice-payments-pagination",
                                      pills: "",
                                      "total-rows": this.newItem.payments
                                        .length,
                                      "per-page": _vm.paymentsPerPage
                                    },
                                    model: {
                                      value: _vm.paymentsCurrentPage,
                                      callback: function($$v) {
                                        _vm.paymentsCurrentPage = $$v
                                      },
                                      expression: "paymentsCurrentPage"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("invoice-tasks-select", {
        ref: "invoiceTaskSelect",
        attrs: { tasks: _vm.tasks },
        on: { addToInvoice: _vm.addToInvoice }
      }),
      _vm._v(" "),
      _c("export-file", { ref: "exportFile" }),
      _vm._v(" "),
      _c("invoice-act", {
        ref: "invoice_act",
        on: { update: _vm.updateInvoiceActs }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-103c29d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103c29d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices/Invoice.vue
// module id = null
// module chunks = 